<template>
  <div class="mainContainer">
    <div class="nav">
      <el-form :model="searchForm" label-width="110px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="所属供应商：">
          <el-input v-model="searchForm.supplierName" size="mini" placeholder="请输入所属供应商" />
        </el-form-item>
        <el-form-item label="库房名称：">
          <el-input v-model="searchForm.warehouseName" size="mini" placeholder="请输入库房名称" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" class="searchBtn" @click="btnClick('add')">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <el-table ref="registerTable" row-key="id" v-loading="tableLoading" :data="tableData" style="width: 100%" border :header-cell-style="headerCellStyle">
        <el-table-column type="index" label="序号" align="center" min-width="50" />
        <el-table-column label="所属供应商" prop="supplierName" align="center" />
        <el-table-column label="供应商类型" prop="supplierType" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.supplierType == 1 ? '公路' : scope.row.supplierType == 2 ? '水路' : scope.row.supplierType == 3 ? '港口及其它' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="库房名称" prop="warehouseName" align="center" />
        <el-table-column label="所在区域" prop="area" align="center" />
        <el-table-column label="详细地址" prop="address" align="center" />
        <el-table-column label="面积(m²)" prop="square" align="center" />
        <el-table-column label="状态" prop="status" align="center" :formatter="statusFormat" />
        <el-table-column label="操作" width="240" align="center">
          <template slot-scope="scope">
            <el-button size="mini" class="searchBtn" @click="btnClick('info', scope.row)">详情 </el-button>
            <el-button size="mini" class="yellow-bg" @click="btnClick('edit', scope.row)">修改 </el-button>
            <el-button size="mini" class="resetBtn" @click="btnClick('delete', scope.row)">删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />
      </div>
    </div>

    <!-- 新增/编辑 -->
    <warehouse-management-form ref="warehouseManagementFormRef" @searchBtn="searchBtn" />
    <!-- 详情 -->
    <warehouse-management-info ref="warehouseManagementInfoRef" />
  </div>
</template>

<script>
  import WarehouseManagementForm from './components/warehouseManagementForm';
  import WarehouseManagementInfo from './components/warehouseManagementInfo';
  import { warehouseManagementDel, warehouseManagementList } from '@/service/warehouse';

  export default {
    name: 'warehouseManagement',
    components: {
      WarehouseManagementForm,
      WarehouseManagementInfo,
    },
    data() {
      return {
        searchForm: {
          supplierName: '',
          warehouseName: '',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.searchBtn();
    },
    methods: {
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      statusFormat(row, column, cellValue) {
        console.log(cellValue);
        switch (cellValue) {
          case 0:
            return '禁用';
          case 1:
            return '启用';
        }
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const { status, message, data } = await warehouseManagementList(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      btnClick(str, row) {
        switch (str) {
          case 'add':
            this.$refs.warehouseManagementFormRef.dialogOpen('新增');
            break;
          case 'edit':
            this.$refs.warehouseManagementFormRef.dialogOpen('修改', row);
            break;
          case 'info':
            this.$refs.warehouseManagementInfoRef.dialogOpen(row.id);
            break;
          case 'delete':
            this.$confirm('确认删除当前数据？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(async () => {
              const { status, message } = await warehouseManagementDel(row.id);
              if (status !== 0) return this.$message.warning(message);
              this.$message.success(message);
              await this.searchBtn();
            });
            break;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
